import React from "react";
import CustomCardsComponent from "../components/customCards/CustomCardsComponent";

const CustomCardsContainer = () => {
  return <CustomCardsComponent />;
};

export default CustomCardsContainer;
